import { createTheme } from '@mui/material/styles';
import { color } from './color';

declare module '@mui/material/styles' {
  interface Theme {
    custom: {
      surface: {
        globalHeaderBg: string;
        contentBg: string;
        leftNavBg: string;
        listHeaderBg: string;
      };
      nav: {
        activeBg: string;
        activeText: string;
      };
      button: {
        updateBg: string;
      };
      border: {
        card: string;
      };
    };
  }
  interface ThemeOptions {
    custom?: {
      surface?: {
        globalHeaderBg?: string;
        contentBg?: string;
        leftNavBg?: string;
        listHeaderBg?: string;
        cardHeaderBg?: string;
      };
      nav?: {
        activeBg?: string;
        activeText?: string;
      };
      button?: {
        updateBg?: string;
      };
      border?: {
        card?: string;
      };
    };
  }
}

export const createAppTheme = (isMedical: boolean) =>
  createTheme({
    palette: {
      primary: {
        main: color.green,
        contrastText: color.white,
      },
      secondary: {
        main: color.button_gray,
        contrastText: color.dark_gray,
      },
      error: {
        main: color.red,
      },
    },
    typography: {
      fontFamily:
        "'Noto Sans JP', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', Meiryo, Osaka, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif",
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            background: color.white,
            '&.Mui-disabled': {
              background: color.bg_light_gray,
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          outlined: {
            '&.Mui-disabled': {
              background: color.bg_light_gray,
            },
          },
        },
      },
    },
    custom: {
      surface: {
        globalHeaderBg: isMedical ? color.md_bg_light_blue : color.white,
        contentBg: isMedical ? color.white : 'transparent',
        leftNavBg: isMedical ? color.md_bg_blue : color.white,
        listHeaderBg: isMedical ? color.white : color.bg_gray,
      },
      nav: {
        activeBg: isMedical ? color.md_nav_active_bg : color.light_green,
        activeText: isMedical ? color.white : color.green,
      },
      button: {
        updateBg: isMedical ? color.md_button_bg : color.white,
      },
      border: {
        card: isMedical ? `1px solid ${color.border_gray}` : 'none',
      },
    },
  });
